export default __webpack_public_path__ + "static/media/m_use_action_hk.42008223.png";